





import Vue from "vue";
import {
  CrusadeForceFormFields,
  CrusadeForceTableHeaders,
} from "@/meta/CrusadeForceModel";
import EntitySearchTable from "@/components/common/EntitySearchTable.vue";
import { ZealotCollections } from "@/services/MongoService";
import RouteNames from "@/router/RouteNames";

export default Vue.extend({
  name: "ForcesTable",
  components: { EntitySearchTable },
  data: () => {
    return {
      tableHeaders: CrusadeForceTableHeaders,
      formFields: CrusadeForceFormFields,
    };
  },
  computed: {
    collection(): string {
      return ZealotCollections.FORCES;
    },
    detailRouteName(): string {
      return RouteNames.FORCE_DETAIL;
    },
  },
});
